import styled from "styled-components";

export default styled.div`
  border-bottom: 1px solid #eee;
  padding: 15px;
  font-weight: bold;
`;
